// M2: extended role set (SUPER_ADMIN = platform-level, max 5 in system)
export type UserRole =
  | 'SUPER_ADMIN'
  | 'ADMIN'
  | 'AGENT'
  | 'OWNER'
  | 'CLIENT'
  | 'PROPERTY_MANAGER'
  | 'LANDLORD'
  | 'VENDOR'
  | 'TENANT'
  | 'AMBASSADOR';

export interface User {
  id: number;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  role: UserRole;
  is2FAEnabled: boolean;
  // M2: org context (populated from JWT claims or admin list endpoint)
  organisationId?: number | null;
  organisationPlan?: string | null;
  organisationName?: string | null;
  // Nested org object returned by the admin /users list endpoint
  organisation?: { id: number; name: string; slug: string; plan: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateUserData {
  role?: UserRole;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  maritalStatus?: string;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  SUPER_ADMIN: 'Platform Administrator',
  ADMIN: 'Administrator',
  AGENT: 'Agent',
  OWNER: 'Owner',
  CLIENT: 'Client',
  PROPERTY_MANAGER: 'Property Manager',
  LANDLORD: 'Landlord',
  VENDOR: 'Vendor',
  TENANT: 'Tenant',
  AMBASSADOR: 'Ambassador',
};
